import { render } from "./DataKeyField.vue?vue&type=template&id=54fc2690"
import script from "./DataKeyField.vue?vue&type=script&lang=js"
export * from "./DataKeyField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__